// extracted by mini-css-extract-plugin
export default {"wrapper":"InputWithIcon_wrapper__J-3oZ","padded-input":"InputWithIcon_padded-input__RZZlY","icon":"InputWithIcon_icon__4u6BM"};